import React, { useState } from "react";

import { Employee } from "../../../dtos/employee";
import { EnrollBiometricsButton } from "../../shared/EnrollBiometricsButton";
import { EnrollBiometricsDialog } from "../../shared/EnrollBiometricsDialog";

interface Props {
    employee: Employee;
    orgId: number | undefined;
    siteId: number | undefined;
    disabled?: boolean;
    compact?: boolean;
}

export function EnrollEmployeeButton({
    employee,
    orgId,
    siteId,
    disabled = false,
    compact = false,
}: Props) {
    const [showEditForm, setShowEditForm] = useState(false);

    return (
        <>
            <EnrollBiometricsButton
                user={employee}
                onSetUserIdToEnroll={() => {
                    setShowEditForm(true);
                }}
                disabled={disabled}
                compact={compact}
            />
            {showEditForm && (
                <EnrollBiometricsDialog
                    user={employee}
                    orgId={orgId}
                    siteId={siteId}
                    onClose={() => setShowEditForm(false)}
                    enrollmentFor="employee"
                />
            )}
        </>
    );
}
